export default __webpack_public_path__ + "static/media/ProductSans-Light.eec71b28.woff2";